const actions = {
  // Criar Categoria/Tipo
  criarCategoria: async (context, { nome, descricao, unidadeId }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.post(`gdd/categoria`, {
      nome,
      descricao,
      unidadeId,
    });

    return response;
  },

  listarCategorias: async (
    context,
    { unidadeId, perPage, page, nome, categoriaUuid }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`gdd/categoria`, {
      params: {
        unidadeId,
        perPage,
        page,
        nome,
        categoriaUuid,
      },
    });

    return response;
  },

  criarTipo: async (context, { nome, validade, categoriaUuid }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.post(`gdd/tipo`, {
      nome,
      validade,
      categoriaUuid,
    });

    return response;
  },

  listarTipos: async (
    context,
    { unidadeId, categoriaUuid, perPage, page, nome }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`gdd/tipo`, {
      params: {
        unidadeId,
        categoriaUuid,
        perPage,
        nome,
        page,
      },
    });

    return response;
  },

  excluirTipo: async (context, { uuid }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.delete(`gdd/tipo/${uuid}`);

    return response;
  },

  excluirCategoria: async (context, { uuid }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.delete(`gdd/categoria/${uuid}`);

    return response;
  },

  editarCategoria: async (context, { uuid, descricao, nome, unidadeId }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.put(`gdd/categoria/${uuid}`, {
      descricao,
      nome,
      unidadeId,
    });

    return response;
  },

  editarTipo: async (context, { nome, validade, categoriaUuid, uuid }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.put(`gdd/tipo/${uuid}`, {
      validade,
      nome,
      categoriaUuid,
    });

    return response;
  },

  // Listar Documentos

  listarDocumentos: async (
    context,
    {
      unidadeId,
      nome,
      descricao,
      CategoriaUuid,
      TipoUuid,
      comArquivo,
      ArquivoUuid,
      status,
      vencimento,
      vencimentoEmDias,
      vigencia,
      perPage,
      page,
      ordenacao,
    }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`gdd/documento`, {
      params: {
        unidadeId,
        nome,
        descricao,
        CategoriaUuid,
        TipoUuid,
        comArquivo,
        ArquivoUuid,
        status,
        vencimento,
        vencimentoEmDias,
        vigencia,
        perPage,
        page,
        ordenacao,
      },
    });

    return response;
  },

  criarDocumento: async (
    context,
    { nome, tipoUuid, descricao, vigencia, vencimento }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.post(`gdd/documento`, {
      nome,
      tipoUuid,
      descricao,
      vigencia,
      vencimento,
    });

    return response;
  },

  excluirDocumento: async (context, { uuid }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.delete(`gdd/documento/${uuid}`);

    return response;
  },

  // Detalhe Documento
  detalharDocumento: async (context, { uuid }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`gdd/documento/${uuid}`);

    return response;
  },

  editarDocumento: async (
    context,
    { uuid, descricao, nome, vigencia, vencimento }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.put(`gdd/documento/${uuid}`, {
      descricao,
      nome,
      vigencia,
      vencimento,
    });

    return response;
  },

  uploadArquivo: async (context, { nome, conteudoBase64, documentoUuid }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.post(`gdd/documento/arquivo`, {
      conteudoBase64,
      documentoUuid,
      nome,
    });

    return response;
  },

  deletarArquivo: async (context, { uuid }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.delete(`gdd/documento/arquivo/${uuid}/excluir`);

    return response;
  },

  ativarDocumento: async (context, { uuid }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.put(`gdd/documento/${uuid}/ativar`);

    return response;
  },

  desativarDocumento: async (context, { uuid }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.put(`gdd/documento/${uuid}/desativar`);

    return response;
  },

  revalidarDocumento: async (context, { uuid, vencimento, vigencia }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.put(`gdd/documento/${uuid}/revalidar`, {
      vencimento,
      vigencia,
    });

    return response;
  },

  statusDocumento: async (context, { uuid }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.put(`gdd/documento/${uuid}/status`);

    return response;
  },

  excluirArquivo: async (context, { uuid }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.delete(`gdd/documento/arquivo/${uuid}`);

    return response;
  },

  logDocumento: async (context, { documentoUuid }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`gdd/documento/log/${documentoUuid}`);

    return response;
  },

  //Upload Criação em Massa
  gerarUrlUpload: async (context) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`gdd/documento/buscarUploadUrl`);

    return response;
  },
  fazerUploadArquivo: async (context, { url, unidadeId }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.post(`gdd/documento/enviarUrlInsercaoEmMassa`, {
      url,
      unidadeId,
    });

    return response;
  },
  // Documentos Optin
  listarAlertasCriados: async (context) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`gdd/alerta`);

    return response;
  },

  criarAlerta: async (
    context,
    { entidade, entidadeUuid, app, email, habilitado }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.post(`gdd/alerta`, {
      entidade,
      entidadeUuid,
      app,
      email,
      habilitado,
    });

    return response;
  },

  // Adicionar origem documento
  listarOrigemDocumento: async (context) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`gdd/vinculo-origem`);

    return response;
  },

  criarOrigemDocumento: async (context, { nomeOrigem }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.post(`gdd/vinculo-origem`, {
      nomeOrigem,
    });

    return response;
  },

  deletarOrigemDocumento: async (context, { nomeOrigem }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.delete(`gdd/vinculo-origem/${nomeOrigem}`);

    return response;
  },
};

export const documento = {
  actions,
  namespaced: true,
};
